import styled from 'styled-components'

export const IntercomContainerStyled = styled.div`
  grid-area: 3 / span 2;
  place-self: end;
  height: ${(props) => props.theme.typography.pxToRem(88)};
  width: 100%;
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
